import {
  Tooltip, TableContainer, Paper,
} from '@mui/material'
import theme from 'src/styles/theme'
import styled from 'styled-components'

export const CustomPaper = styled(Paper)<{ $flatTable?: boolean }>`
  border: ${(props) => (props.$flatTable ? `1px solid ${theme.colors.gray4}` : 'none')}
`

export const TableContainerStyled = styled(TableContainer)`
  .MuiTableHead-root .MuiTableRow-root .MuiTableCell-head {
      font-weight: bold;
      resize: horizontal;
      overflow-x: overlay;
      overflow-y: hidden;
      border-right: 0.5px solid;
  }
`

export const TableMuiLabel = styled.div<{ backgroundColor?: string }>`
  background: ${(props) => (props.backgroundColor ? props.backgroundColor : theme.colors.blue)};
  width: 100%;
  color: ${theme.colors.white};
  font-weight: bold;
  padding: 16px;
  font-size: 14px;
`

export const whiteHeaderStyle = {
  backgroundColor: theme.colors.white,
  color: theme.colors.darkGray,
}

export const flatTableStyle = {
  backgroundColor: theme.colors.white,
  color: theme.colors.blue,
}

export const darkHeaderStyle = {
  backgroundColor: theme.colors.blue,
  color: theme.colors.white,
}

export const CellTooltip = styled(Tooltip)`
  cursor: pointer;
`

export const TooltipStyle = {
  gap: '4px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}

export const CheckboxSelectAllTooltip = styled(Tooltip)`
`
